import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Weddings from "./pages/Weddings";
import Quinceaneras from "./pages/Quinceaneras";
import Events from "./pages/Events";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import About from "./pages/About";
import QRCodePage from "./pages/QRCodePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/weddings" element={<Weddings />} />
          <Route path="/quinceaneras" element={<Quinceaneras />} />
          <Route path="/events" element={<Events />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/qr" element={<QRCodePage />} />
          <Route path="/pricing" element={<Navigate to="/contact" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
